import React, { useContext, useEffect } from 'react';
import Touches from '../touches/Touches';
//import TouchForm from '../touches/touchForm';
import TouchesFilter from '../touches/TouchesFilter';
import AuthContext from '../../context/auth/authContext';

const TouchesPage = () => {
  const authContext = useContext(AuthContext);

  const { user } = authContext;

  useEffect(() => {
    authContext.loadUser();
    //eslint-disable-next-line
  }, []);

  if (user && ['admin'].indexOf(user.role) !== -1) {
    return (
      <div>
        <TouchesFilter />
        <Touches />
      </div>
    );
  } else {
    return <div>{/* <h1>Not Authorized</h1> */}</div>;
  }
};

export default TouchesPage;
